export class FieldValueResultDto {
    fieldName: string;
    fieldValue: string;
}
